
import React, { useState, useEffect } from "react";

function Prompt(props) {
  const{when, message} = props
  const onBeforeUnload = (ev) => {
       ev.returnValue = message;
      //return message;
      return true;
  };
  useEffect(() => {
    window.addEventListener("beforeunload", onBeforeUnload);
/*
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };*/
  }, []);
 

  return <div/>;
}

export default Prompt;
